
const serviceData = [
  {
    id: 1,
    title: "City Transfer",
    icon: "ri-map-pin-2-line",
    desc: "from different cities customers can give as well take machinary on rent",
  },

  // {
  //   id: 2,
  //   title: "Whole  City Tour",
  //   icon: "ri-home-fill",
  //   desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
  // },

  // {
  //   id: 3,
  //   title: "Unlimited Miles Car Rental",
  //   icon: "ri-roadster-line",
  //   desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
  // },

  {
    id: 2,
    title: "Fast & Easy Booking",
    icon: "ri-timer-flash-line",
    desc: "Very fast and efficient booking can be done by any one ",
  },

  {
    id: 3,
    title: "One can post their machinary Easily",
    icon: "ri-map-pin-line",
    desc: "Any verified customer can post he equipmets to rental purpose easily",
  },

  {
    id: 4,
    title: "Customer Support",
    icon: " ri-message-line",
    desc: "We offers every kind of support to our customers",
  },
];

export default serviceData;

// const serviceData = [
//   {
//     id: 1,
//     title: "invidunt sed",
//     icon: "ri-map-pin-2-line",
//     desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
//   },

//   {
//     id: 2,
//     title: "Lorem sadipscing",
//     icon: "ri-home-fill",
//     desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
//   },

//   {
//     id: 3,
//     title: "Dolor ut",
//     icon: "ri-roadster-line",
//     desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
//   },

//   {
//     id: 4,
//     title: "sadipscing vero",
//     icon: "ri-timer-flash-line",
//     desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
//   },

//   {
//     id: 5,
//     title: "Gubergren gub",
//     icon: "ri-map-pin-line",
//     desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
//   },

//   {
//     id: 6,
//     title: " sadipscing vero",
//     icon: "ri-flight-takeoff-line",
//     desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
//   },
// ];

// export default serviceData;
